// Core
import styled from 'styled-components';

export const SensorsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LabelsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin: 16px 0;
`;

export const Separator = styled.div`
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.borderColor};
  margin-bottom: 16px;
  margin-right: 8px;
`;

export const LastSeparator = styled.div`
 border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.borderColor};
 margin-bottom: 16px;
`;

export const EnableItemsContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
  margin-right: 8px;
`;

export const LastEnableItemsContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;
